(function () {
  function moneyAndVariant(card) {
    var select = card.querySelector('[data-card-variant]');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var image = card.querySelector('.card-image img');
    var link = card.querySelector('.card-image');
    var price = card.querySelector('[data-card-price]');
    var compare = card.querySelector('[data-card-compare]');
    var button = card.querySelector('.card-add');
    if (price) price.textContent = option.dataset.price;
    if (compare) { compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare; }
    if (option.dataset.image && image) { image.src = option.dataset.image; image.srcset = ''; image.alt = option.dataset.imageAlt || image.alt; }
    if (option.dataset.url && link) link.href = option.dataset.url;
    if (button) { var available = option.dataset.available === 'true'; button.disabled = !available; button.querySelector('[data-add-label]').textContent = available ? 'In winkelmand' : 'Uitverkocht'; }
  }

  document.querySelectorAll('[data-product-card]').forEach(function (card) {
    var select = card.querySelector('[data-card-variant]');
    if (select) {
      var requestedColors = [];
      new URLSearchParams(location.search).forEach(function (value, key) { if (key === 'hh_color' || key.indexOf('custom.basiskleuren') !== -1) requestedColors.push(value.toLowerCase()); });
      if (requestedColors.length) {
        var matchingOption = [].slice.call(select.options).find(function (option) { var colors = (option.dataset.baseColors || '').split('|'); return requestedColors.some(function (color) { return colors.indexOf(color) !== -1; }); });
        if (matchingOption) select.value = matchingOption.value;
      }
      moneyAndVariant(card);
      select.addEventListener('change', function () { moneyAndVariant(card); });
    }
    var form = card.querySelector('[data-card-form]');
    if (!form) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('.card-add');
      var message = form.querySelector('[data-card-message]');
      button.disabled = true;
      message.textContent = '';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (response) { if (!response.ok) throw new Error(); return response.json(); })
        .then(function () { return fetch('/cart.js').then(function (response) { return response.json(); }); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = cart.item_count; });
          message.textContent = 'Toegevoegd aan je winkelmand';
          button.querySelector('[data-add-label]').textContent = 'Toegevoegd ✓';
          setTimeout(function () { moneyAndVariant(card); message.textContent = ''; }, 1800);
        })
        .catch(function () { message.textContent = 'Dat lukte niet. Probeer opnieuw.'; moneyAndVariant(card); });
    });
  });

  var open = document.querySelector('[data-filter-open]');
  var close = document.querySelector('[data-filter-close]');
  var overlay = document.querySelector('[data-filter-overlay]');
  function toggleFilters(show) { document.body.classList.toggle('filter-open', show); if (open) open.setAttribute('aria-expanded', String(show)); }
  if (open) open.addEventListener('click', function () { toggleFilters(true); });
  if (close) close.addEventListener('click', function () { toggleFilters(false); });
  if (overlay) overlay.addEventListener('click', function () { toggleFilters(false); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape') toggleFilters(false); });

  var sort = document.querySelector('[data-sort-select]');
  if (sort) sort.addEventListener('change', function () { var url = new URL(location.href); url.searchParams.set('sort_by', sort.value); url.hash = 'catalogus'; location.href = url.toString(); });

  function applyLocalFilters() {
    var grid = document.querySelector('[data-filter-grid]');
    if (!grid) return;
    var params = new URLSearchParams(location.search);
    var materials = params.getAll('hh_material').map(function (value) { return value.toLowerCase(); });
    var colors = params.getAll('hh_color').map(function (value) { return value.toLowerCase(); });
    var needleMin = parseFloat(params.get('hh_needle_min'));
    var needleMax = parseFloat(params.get('hh_needle_max'));
    var weightMin = parseFloat(params.get('hh_weight_min'));
    var weightMax = parseFloat(params.get('hh_weight_max'));
    var lengthMin = parseFloat(params.get('hh_length_min'));
    var lengthMax = parseFloat(params.get('hh_length_max'));
    var hasNumber = function (number) { return !Number.isNaN(number); };
    var active = materials.length || colors.length || [needleMin, needleMax, weightMin, weightMax, lengthMin, lengthMax].some(hasNumber);

    document.querySelectorAll('[data-local-filter-group] input').forEach(function (input) {
      if (input.type === 'checkbox') input.checked = params.getAll(input.name).indexOf(input.value) !== -1;
      else input.value = params.get(input.name) || '';
    });
    if (!active) return;

    var visible = 0;
    grid.querySelectorAll('[data-product-card]').forEach(function (card) {
      var cardMaterials = (card.dataset.filterMaterials || '').split('|');
      var cardColors = (card.dataset.filterColors || '').split('|');
      var cardNeedleMin = parseFloat(card.dataset.filterNeedleMin);
      var cardNeedleMax = parseFloat(card.dataset.filterNeedleMax);
      var cardWeight = parseFloat(card.dataset.filterWeight);
      var cardLength = parseFloat(card.dataset.filterLength);
      var show = (!materials.length || materials.some(function (material) { return cardMaterials.indexOf(material) !== -1; }))
        && (!colors.length || colors.some(function (color) { return cardColors.indexOf(color) !== -1; }))
        && (!hasNumber(needleMin) || (hasNumber(cardNeedleMax) && cardNeedleMax >= needleMin))
        && (!hasNumber(needleMax) || (hasNumber(cardNeedleMin) && cardNeedleMin <= needleMax))
        && (!hasNumber(weightMin) || (hasNumber(cardWeight) && cardWeight >= weightMin))
        && (!hasNumber(weightMax) || (hasNumber(cardWeight) && cardWeight <= weightMax))
        && (!hasNumber(lengthMin) || (hasNumber(cardLength) && cardLength >= lengthMin))
        && (!hasNumber(lengthMax) || (hasNumber(cardLength) && cardLength <= lengthMax));
      card.hidden = !show;
      if (show) visible += 1;
    });
    var count = document.querySelector('.result-count strong');
    if (count) count.textContent = visible;
    var empty = document.querySelector('[data-local-empty]');
    if (empty) empty.hidden = visible !== 0;
  }
  applyLocalFilters();

  document.querySelectorAll('[data-product-detail]').forEach(function(root){
    var script=root.querySelector('[data-product-json]'); if(!script)return;
    var product=JSON.parse(script.textContent), variantSelect=root.querySelector('#VariantSelect'), price=root.querySelector('#ProductPrice'), mainImage=root.querySelector('#ProductMainImage'), submit=root.querySelector('button[type="submit"]'), thumbs=[].slice.call(root.querySelectorAll('.thumbs button'));
    function chosen(){return [].slice.call(root.querySelectorAll('.option-group')).map(function(fs){var input=fs.querySelector('input:checked');return input&&input.value;});}
    function apply(variant){if(!variant)return;variantSelect.value=variant.id;var option=[].slice.call(variantSelect.options).find(function(o){return o.value==variant.id;});if(price)price.textContent=option.dataset.price;if(option.dataset.image&&mainImage){mainImage.src=option.dataset.image;thumbs.forEach(function(b){b.classList.toggle('is-active',b.dataset.imageId===option.dataset.imageId);});}submit.disabled=option.dataset.available!=='true';submit.textContent=submit.disabled?'Uitverkocht':'In winkelwagen';var url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
    root.querySelectorAll('.option-group input').forEach(function(input){input.addEventListener('change',function(){var values=chosen();apply(product.variants.find(function(v){return v.options.every(function(o,i){return o===values[i];});}));});});
    thumbs.forEach(function(button){button.addEventListener('click',function(){var variant=product.variants.find(function(v){return String(v.id)===button.dataset.variantId;});if(variant)apply(variant);else if(mainImage){mainImage.src=button.dataset.image;thumbs.forEach(function(b){b.classList.toggle('is-active',b===button);});}});});
  });
})();
